// Declare action names as constants with uppercase string

import AzureServices from '../services/AzureServices';
export const BLOB_BEGIN = 'BLOB_BEGIN';
export const BLOB_SUCCESS = 'BLOB_SUCCESS';
export const BLOB_FAILURE = 'BLOB_FAILURE';

// Thunk: this is a special type of action that can dispatch other actions
export function generateBlob(data, file, token) {
    return async dispatch => {
        dispatch(blobBegin());
        await AzureServices.createBlob(data, file, token)
            .then(
                result => {
                        dispatch(blobSuccess(result));
                },
                error => {
                    dispatch(blobFailure(error));
                    // throw ({ error: error, message: 'Ops! user authentication failed' });
                }
            )
    };
}

// Action: Function that returns an object with action data for reducer
export const blobBegin = () => ({
    type: BLOB_BEGIN
});
export const blobSuccess = data => ({
    type: BLOB_SUCCESS,
    payload: { data }
});
export const blobFailure = error => ({
    type: BLOB_FAILURE,
    payload: { error }
});